// extracted by mini-css-extract-plugin
module.exports = {"aboutContainer":"About_aboutContainer__324XA"};